/**
 * Formats a numeric value by adding commas to separate thousands, millions, etc.
 *
 * @param value - The numeric value to be formatted. It can be either a number or a string.
 * @returns The formatted numeric value as a string with commas or the original value if not a valid number.
 */
export const withCommas = (value: number | string) => {
  const numericValue = typeof value === "string" ? parseFloat(value) : value;

  if (!isNaN(numericValue)) {
    return numericValue.toLocaleString();
  }

  return value;
};
